import { pick } from '../../../_internal_/utils';
const SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
// нестандартный
'tabSize', 'textIndent',
// нестандартный
'textRendering', 'textTransform', 'width', 'wordBreak'];
const getSizingData = node => {
  const style = window?.getComputedStyle(node);
  if (style === null) {
    return null;
  }
  const sizingStyle = pick(style, SIZING_STYLE);
  const {
    boxSizing
  } = sizingStyle;

  // вероятно, узел отсоединен от DOM, не может прочитать вычисленные размеры
  if (boxSizing === '') return null;
  const paddingSize = parseFloat(sizingStyle?.paddingBottom ?? 0) + parseFloat(sizingStyle?.paddingTop ?? 0);
  const borderSize = parseFloat(sizingStyle?.borderBottomWidth ?? 0) + parseFloat(sizingStyle?.borderTopWidth ?? 0);
  return {
    sizingStyle,
    paddingSize,
    borderSize
  };
};
export default getSizingData;